import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlSortBarIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 5.25H1C0.59 5.25 0.25 5.59 0.25 6C0.25 6.41 0.59 6.75 1 6.75H23C23.41 6.75 23.75 6.41 23.75 6C23.75 5.59 23.41 5.25 23 5.25Z"
        fill={color}
      />
      <path
        d="M19 12.25H5C4.59 12.25 4.25 12.59 4.25 13C4.25 13.41 4.59 13.75 5 13.75H19C19.41 13.75 19.75 13.41 19.75 13C19.75 12.59 19.41 12.25 19 12.25Z"
        fill={color}
      />
      <path
        d="M14.5 19.25H9.5C9.09 19.25 8.75 19.59 8.75 20C8.75 20.41 9.09 20.75 9.5 20.75H14.5C14.91 20.75 15.25 20.41 15.25 20C15.25 19.59 14.91 19.25 14.5 19.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlSortBarIcon.displayName = 'CtrlSortBarIcon';
